class Cart {
  cartCount;
  
  constructor() {
    this.init();
  }
  
  init() {
      fetch('/cart.js')
      .then(response => {
        return response.json();
      })
      .then(cart => {
        if (cart.item_count === 0) {
          this.cartCount = 0;
          localStorage.removeItem("token");
        } else {
          this.cartCount = cart['items'].filter((obj) => obj.id !== 32955271741540).length;
          fetch('/cart/update.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({
              'updates': {
                '32955271741540': this.cartCount
            }})
          });
          console.log("fee updated");
        }
      })
      .catch((error) => {
        console.error('Error:', error);
      });
  }

  checkout(event) {
    console.log("checkout requested");
    if (!localStorage.getItem("token")) {
      event.preventDefault();
      return false;
    }
    return true;
  }
}

var localCart = new Cart();